import { word } from "@modules/core/utils/i18n"
import { ProgramDetailsPageContent } from "@modules/programs/components/programDetailsPageContent"
import { ProgramErrorView } from "@modules/programs/components/programErrorView"
import { ProgramSubscribingView } from "@modules/programs/components/programSubscribingView"
import { LoadingSpinner } from "@modules/ui/components/loading"
import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"
import { useParams } from "react-router"

export function ProgramDetailsPage({ isSubscribingPage = false }: { isSubscribingPage?: boolean }) {
  const { programId } = useParams()

  if (!programId) {
    return <div>{word("program.form.on-off.duplicateProgramNotFound")}</div>
  }

  return (
    <ErrorBoundary fallback={<ProgramErrorView />}>
      <div className="relative h-full w-full">
        {isSubscribingPage && <ProgramSubscribingView programId={programId} />}

        <Suspense fallback={<LoadingSpinner />}>
          <ProgramDetailsPageContent
            key={programId}
            programId={programId}
            className={isSubscribingPage ? "opacity-10" : ""}
          />
        </Suspense>
      </div>
    </ErrorBoundary>
  )
}
